import React from "react";
import "./ContentSection.css";

export interface ContentSectionProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
  variant?: "default" | "card" | "transparent";
}

const ContentSection: React.FC<ContentSectionProps> = ({
  children,
  title,
  subtitle,
  actions,
  className = "",
  variant = "default",
}) => {
  return (
    <section
      className={`content-section content-section-${variant} ${className}`}
      data-testid="content-section"
    >
      {(title || actions) && (
        <div className="content-section-header">
          <div className="content-section-titles">
            {title && <h2 className="content-section-title">{title}</h2>}
            {subtitle && <p className="content-section-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="content-section-actions">{actions}</div>}
        </div>
      )}

      <div className="content-section-body">{children}</div>
    </section>
  );
};

export default ContentSection;
